import React from "react";
import { useNavigate } from "react-router-dom";
import { FaLock } from "react-icons/fa";
import "./SessionExpiredModal.css";

function SessionExpiredModal({ show, onConfirm }) {
  const navigate = useNavigate();

  if (!show) return null;

  return (
    <div className="modal-backdrop">
      <div className="modal-box">
        <div className="modal-icon-wrapper">
          <FaLock className="modal-icon" />
        </div>
        <h5>Session Expired</h5>
        <p>Your security session has ended. Please sign in again to access the hub.</p>
        <button className="modal-btn" onClick={() => {
          onConfirm();
          navigate("/login");
        }}>
          Return to Login
        </button>
      </div>
    </div>
  );
}

export default SessionExpiredModal;
